import {
  AutocompleteInput,
  DateInput,
  FormInput,
  RadioGroupInput,
} from '@kirz/mui-admin';
import { Alert, Link } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import React from 'react';

import { ClientAutocompleteInput } from 'components/ClientAutocompleteInput';

export interface ClientFormFieldsProps {
  existingClient?: any | null;
  leadSources: string[];
  disablePhone?: boolean;
  type?: 'individual' | 'legal';
}

export function ClientFormFields({
  existingClient,
  leadSources,
  disablePhone,
  type = 'individual',
}: ClientFormFieldsProps) {
  const individual = type === 'individual';

  return (
    <>
      {existingClient && (
        <Grid xs={12}>
          <Alert severity="error">
            Номер телефона +{existingClient.phone} уже принадлежит пользователю{' '}
            <Link href={`/clients/${existingClient.id}`}>
              {existingClient.fullName}
            </Link>
          </Alert>
        </Grid>
      )}
      {individual ? (
        <>
          <FormInput name="secondName" label="Фамилия" md={4} autoFocus />
          <FormInput name="firstName" label="Имя" md={4} required />
          <FormInput name="middleName" label="Отчество" md={4} />
          <FormInput
            name="phone"
            label="Телефон"
            md={4}
            type="phone"
            required
            disabled={disablePhone}
          />
          <FormInput name="email" label="E-mail" md={4} type="email" />
          <AutocompleteInput
            name="source"
            label="Источник"
            md={4}
            required
            options={leadSources.map((x) => ({ value: x, text: x }))}
          />

          <AutocompleteInput
            name="userId"
            mode="hasura"
            source="user"
            label="Эксперт"
            selection="id fullName"
            itemText="fullName"
            md={5}
            required
          />
          <DateInput name="birthday" label="День рождения" sm={6} md={3} />
          <RadioGroupInput
            name="gender"
            label="Пол"
            sm={6}
            md={4}
            items={[
              { text: 'муж.', value: 'male' },
              { text: 'жен.', value: 'female' },
            ]}
          />
        </>
      ) : (
        <>
          <FormInput
            name="firstName"
            label="Название"
            md={8}
            required
            autoFocus
          />

          <AutocompleteInput
            name="userId"
            mode="hasura"
            source="user"
            label="Эксперт"
            selection="id fullName"
            itemText="fullName"
            md={4}
            required
          />
          <FormInput
            name="legalCeoFullname"
            label="ФИО генерального директора"
            md={12}
            required
          />
          <FormInput name="inn" label="ИНН" sm={6} md={4} required />
          <FormInput name="legalKpp" label="КПП" sm={6} md={4} required />
          <FormInput name="legalOgrn" label="ОГРН" sm={6} md={4} required />
          <FormInput
            name="legalAddress"
            label="Юридический адрес"
            sm={12}
            md={6}
            required
          />
          <FormInput
            name="legalActualAddress"
            label="Фактический адрес"
            sm={12}
            md={6}
            required
          />
          <FormInput name="legalCurrentAccount" label="Расчетный счёт" md={6} />
          <FormInput
            name="legalCorrespondentAccount"
            label="Корреспондентский счёт"
            md={6}
            required
          />
          <FormInput
            name="phone"
            label="Телефон"
            md={4}
            type="phone"
            required
            disabled={disablePhone}
          />
          <FormInput name="email" label="E-mail" md={4} type="email" />
          <ClientAutocompleteInput
            name="legalContactClientId"
            label="Контактное лицо"
            showOpenInNew={false}
            md={4}
          />
        </>
      )}

      <FormInput
        name="comment"
        label="Комментарий"
        type="text"
        multiline
        rows={2}
      />
    </>
  );
}
